export { Badge, type BadgeProps } from './styled/badge';
